import { Box, Typography, useTheme } from '@mui/material';

type MarketingHeroProps = {
  eyebrow?: string;
  title: string;
  titleAccent?: string;
  description?: string;
};

export const MarketingHero = ({
  eyebrow,
  title,
  titleAccent,
  description,
}: MarketingHeroProps) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        mb: { xs: 4, md: 6 },
        textAlign: { xs: 'left', md: 'center' },
        maxWidth: 900,
        mx: 'auto',
      }}
    >
      {eyebrow && (
        <Typography
          variant="overline"
          sx={{ color: 'primary.main', fontWeight: 700, letterSpacing: 1.2 }}
        >
          {eyebrow}
        </Typography>
      )}
      <Typography
        variant="h3"
        component="h2"
        sx={{
          fontWeight: 800,
          fontSize: { xs: '1.75rem', md: '2.5rem' },
          lineHeight: 1.15,
          mt: eyebrow ? 1 : 0,
        }}
      >
        {title}
        {titleAccent && (
          <Box
            component="span"
            sx={{ color: theme.palette.mainColors.primary, display: 'block' }}
          >
            {titleAccent}
          </Box>
        )}
      </Typography>
      {description && (
        <Typography
          variant="body1"
          color="text.secondary"
          sx={{ mt: 2, lineHeight: 1.7 }}
        >
          {description}
        </Typography>
      )}
    </Box>
  );
};
